import React, { useState, useEffect } from "react";
import {Grid} from "@mui/material";
import BettingIcon from "../../Svg/BettingIcon";
import UtilityIcon from "../../Svg/UtilityIcon";
import CableIcon from "../../Svg/CableIcon";
import AirTimeIcon from "../../Svg/AirTimeIcon";
import DataIcon from "../../Svg/DataIcon";
import OtherBillIcon from "../../Svg/OtherBillIcon";
import { Paper, styled, Box, Switch } from "@mui/material";
import FormControlLabel from "@mui/material/FormControlLabel";
import CustomStack from "../../components/Stack";
import CustomSlider from "../../components/CustomSlider";
import { useNavigate } from "react-router-dom";
import { ApiUrls } from "../../Services/Routes/API";
import { headersPost } from "../../Services/API";
import { MainRoutes } from "../../Services/Routes/App";
import SlideList from "../../components/SideList";
import TransactionTable from "../../components/TransactionTable";
import TransactionBar from "../../components/TransactionBar";
import SuccessCard from "../../components/SuccessCard";
import LoadCard from "../../components/LoadCard";
import ViewModal from "../../components/ViewModal";


// stylings
const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: "center",
  color: theme.palette.text.secondary,
}));

const Transaction = () => {
  // const
  const navigate = useNavigate();

  // states

  const [open, setOpen] = useState(false);
  const [cards, setCards] = useState([]);
  const [alertOpen, setAlertOpen] = useState(false);
  const [alertMsg, setAlertMsg] = useState("");
  const [alertIcon, setAlertIcon] = useState("error");
  const [transactionTableData, setTransactionTableData] = useState([]);
  const [transactionRow, setTransactionRow] = useState({});
  const [openView, setOpenView] = useState(false);


  // states
  const lists = [
    {
      icon: <BettingIcon />,
      text: "Betting",
    },
    {
      icon: <UtilityIcon />,
      text: "Utility Bills",
    },
    {
      icon: <CableIcon />,
      text: "Cable",
    },
    {
      icon: <AirTimeIcon />,
      text: "Airtime",
    },
    {
      icon: <DataIcon />,
      text: "Data",
    },
    {
      icon: <OtherBillIcon />,
      text: "Other Bill Payments",
    },
  ];

  const updateUserData = (item) => {
    setTransactionRow(item);
    setOpenView(true);
  };

  const getCardsData = () => {
    const data = {
      request_type: "transaction",
    };
    setOpen(true);
    headersPost(ApiUrls.GET_DASHBOARD_DATA, data)
      .then((res) => {
        if (res?.status === 200 && res?.data?.success) {
          setCards(res.data?.wallets);
          setOpen(false);
        } else {          
          setAlertOpen(true);      
          setAlertMsg(res?.data?.message);
          setAlertIcon("warning");
        }
      })
      .catch((err) => {
        const { response } = err;
        if (response?.status === 401) {
          localStorage.clear(); 
          navigate(MainRoutes?.root); 
        } else {
          setAlertOpen(true);
          setAlertMsg(response?.statusText);
          setAlertIcon("error");
        }
      });
  };

  useEffect(() => {
    getCardsData();
  }, []);

  return (
    <Box>
      <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 6 }}>
        <Grid
          item
          xs={12}
          sm={12}
          md={8}
          sx={{ marginTop: "40px", width: "72vw" }}
        >
          <CustomStack />
          <Box>
            <FormControlLabel
              sx={{
                width: "80%",
              }}
              margin="75px"
              value="start"
              control={<Switch color="primary" />}
              label="Default Wallet"
              labelPlacement="start"
            />
          </Box>
          <CustomSlider cards={cards} />
          <TransactionBar text="Transaction History"/>
        </Grid>
        <Grid item sm={4} xs={12} md={4} sx={{marginTop: "50px"}}>
          <SlideList cards={cards}  />
        </Grid>
      </Grid>
      <Grid item sm={12} xs={12} md={12}>      
        <TransactionTable />     
      </Grid>
    
      {/* <ViewModal
        open={openView}
        onClose={() => {
          setOpenView(false);
        }}
        row={transactionRow}
      /> */}


    </Box>                              

  );
 
};

export default Transaction;
